export const toRequestParams = (data: object): Record<string, string> => {
    const record = data as Record<string, unknown>;
    const params: Record<string, string> = {};
    for (const key in record) {
        if (record[key] !== undefined && record[key] !== null) {
            if (Array.isArray(record[key])) {
                if ((record[key] as unknown[]).length > 0) {
                    params[key] = (record[key] as unknown[]).join(',');
                }
            } else {
                params[key] = String(record[key]);
            }
        }
    }

    return params;
};
